import React, { Component } from 'react';

class ApartmentV1 extends Component {
    render() {
        let publicUrl = process.env.PUBLIC_URL + '/';
        let CustomClass = this.props.CustomClass ? this.props.CustomClass : '';

        return (
            <div className={"ltn__apartments-plan-area pt-115--- pb-70 " }>
                <div id='plans' className="container pt-115">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title-area ltn__section-title-2--- text-center">
                                <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                                    Plans du bâtiment
                                </h6>
                                <h1 className="section-title">Présentation des niveaux</h1>
                            </div>
                            <div className="ltn__tab-menu ltn__tab-menu-3 ltn__tab-menu-top-right-- text-uppercase--- text-center">
                                <div className="nav">
                                    <a className="active show" data-bs-toggle="tab" href="#ss2">Sous-sol</a>
                                    <a data-bs-toggle="tab" href="#rdc">Rez-de-chaussée</a>
                                    <a data-bs-toggle="tab" href="#local">Local commercial</a>
                                    <a data-bs-toggle="tab" href="#etages">Étages (1<sup>er</sup> au 4<sup>e</sup>)</a>
                                    <a data-bs-toggle="tab" href="#terrasse">Terrasse</a>
                                </div>
                            </div>
                            <div className="tab-content">
                                
                            
								{/* Sous-sol  */}
                                <div className="tab-pane fade active show" id="ss2">
                                    <div className="ltn__apartments-tab-content-inner">
                                        <div className="row" style={{ alignItems: 'center' }}>
                                            <div className="col-lg-6">
                                                <div className="apartments-plan-info ltn__secondary-bg text-color-white">
                                                    <h2>Sous-sol </h2>
                                                    <p>
                                                        Niveau destiné au stationnement des véhicules et locaux techniques du bâtiment. Sécurité incendie et accès ascenseur/escaliers assurés.
                                                    </p>
                                                    <div className="apartments-info-list apartments-info-list-color mt-40">
                                                        <ul>
                                                            <li><label>Usage</label> <span>Parking, techniques</span></li>
                                                            <li><label>Accès</label> <span>Ascenseur & escalier</span></li>
                                                            <li><label>Sécurité</label> <span>Détection incendie</span></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="apartments-plan-img">
                                                    <img src={publicUrl + "assets/img/others/soussol2.png"} alt="Sous-sol 2" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Rez-de-chaussée */}
                                <div className="tab-pane fade" id="rdc">
                                    <div className="ltn__apartments-tab-content-inner">
                                        <div className="row" style={{ alignItems: 'center' }}>
                                            <div className="col-lg-6">
                                                <div className="apartments-plan-info ltn__secondary-bg text-color-white">
                                                    <h2>Rez-de-chaussée</h2>
                                                    <p>
                                                        Entrée principale de la résidence, accès au hall, ascenseur, escaliers et au local commercial. Circulation fluide et sécurité renforcée.
                                                    </p>
                                                    <div className="apartments-info-list apartments-info-list-color mt-40">
                                                        <ul>
                                                            <li><label>Usage</label> <span>Accueil, accès résidentiel</span></li>
                                                            <li><label>Services</label> <span>Ascenseur, escalier, local commercial</span></li>
                                                            <li><label>Sécurité</label> <span>Contrôle d’accès</span></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="apartments-plan-img">
                                                    <img src={publicUrl + "assets/img/others/rdc.png"} alt="Rez-de-chaussée" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Local commercial */}
                                <div className="tab-pane fade" id="local">
                                    <div className="ltn__apartments-tab-content-inner">
                                        <div className="row" style={{ alignItems: 'center' }}>
                                            <div className="col-lg-6">
                                                <div className="apartments-plan-info ltn__secondary-bg text-color-white">
                                                    <h2>Local commercial</h2>
                                                    <p>
                                                        Espace commercial de près de 200 m², idéal pour toute activité de commerce ou de services, visible depuis la rue et facilement accessible.
                                                    </p>
                                                    <div className="apartments-info-list apartments-info-list-color mt-40">
                                                        <ul>
                                                            <li><label>Surface</label> <span>199,62 m²</span></li>
                                                            <li><label>Emplacement</label> <span>Rez-de-chaussée</span></li>
                                                            <li><label>Accessibilité</label> <span>Entrée principale</span></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="apartments-plan-img">
                                                    <img src={publicUrl + "assets/img/others/rdc.png"} alt="Local commercial" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Étages (1er au 4e) */}
                                <div className="tab-pane fade" id="etages">
                                    <div className="ltn__apartments-tab-content-inner">
                                        <div className="row" style={{ alignItems: 'center' }}>
                                            <div className="col-lg-6">
                                                <div className="apartments-plan-info ltn__secondary-bg text-color-white">
                                                    <h2>Étages (1<sup>er</sup> au 4<sup>e</sup>)</h2>
                                                    <p>
                                                        Chaque étage comprend plusieurs appartements : 2 chambres, salon, séjour, cuisine, salle de bain et balcon. Surfaces types : 57,91 m², 59,25 m², 66,78 m². Distribution optimisée pour la vie de famille.
                                                    </p>
                                                    <div className="apartments-info-list apartments-info-list-color mt-40">
                                                        <ul>
                                                            <li><label>Nombre d’étages</label> <span>4</span></li>
                                                            <li><label>Surfaces</label> <span>De 57 à 67 m²</span></li>
                                                            <li><label>Équipements</label> <span>Balcon, cuisine équipée, isolation</span></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="apartments-plan-img">
                                                    <img src={publicUrl + "assets/img/others/etage-type.png"} alt="Étages type" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Terrasse */}
                                <div className="tab-pane fade" id="terrasse">
                                    <div className="ltn__apartments-tab-content-inner">
                                        <div className="row" style={{ alignItems: 'center' }}>
                                            <div className="col-lg-6">
                                                <div className="apartments-plan-info ltn__secondary-bg text-color-white">
                                                    <h2>Terrasse</h2>
                                                    <p>
                                                        Terrasse commune accessible à tous les résidents : idéale pour espace vert, détente, activités ou aire de jeux, sécurisée par des garde-corps.
                                                    </p>
                                                    <div className="apartments-info-list apartments-info-list-color mt-40">
                                                        <ul>
                                                            <li><label>Usage</label> <span>Espace partagé</span></li>
                                                            <li><label>Vue</label> <span>Dégagée</span></li>
                                                            <li><label>Sécurité</label> <span>Garde-corps</span></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="apartments-plan-img">
                                                    <img src={publicUrl + "assets/img/others/terrasse.png"} alt="Terrasse" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* /fin tabs */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ApartmentV1;
